import { React } from 'react';
import { Shelf } from '../components';

export default function Fireside() {
    return (
        <div className="fireside">                      
            {<Shelf shelfName="Fireside" tableItemsPath="recode/fireside/stories"/>}
        </div>        
    )
};